module.exports = __webpack_public_path__ + "static/img/partner_bg.d126158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_bg.png
// module id = BdFz
// module chunks = 9